import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { HomeBtnRockBgImg } from "@/assets"
import { Button } from "@/ui/Button"
import { IButtonInRock } from "."
import styles from "./ButtonInRock.module.scss"

export const ButtonInRock: FC<PropsWithChildren<IButtonInRock>> = ({
  children,

  classNameContainer,

  className,
  ...rest
}) => {
  return (
    <div className={clsx(styles.ButtonInRock, classNameContainer)}>
      <div className={clsx(styles.ButtonInRock_bg)}>
        <img src={HomeBtnRockBgImg} alt="home btn rock bg" />
      </div>
      <Button className={clsx(styles.ButtonInRock_button, className)} {...rest}>
        {children}
      </Button>
    </div>
  )
}
